import { CustomSliderRoot } from "./CustomSlider.styles";
import { SliderThumb } from "@mui/material/Slider";

function AirbnbThumbComponent(props) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="thumb-bar" />
      <span className="thumb-bar" />
      <span className="thumb-bar" />
    </SliderThumb>
  );
}

export const CustomSlider = (props) => {
  const { min, max, step, label, marks, value, onChange, valueLabelFormatter } =
    props;

  function valuetext(value) {
    // If a valueFormatter function is provided, use it
    if (valueLabelFormatter) {
      return valueLabelFormatter(value);
    }
    return value;
  }

  return (
    <CustomSliderRoot
      aria-label={label}
      value={value}
      valueLabelFormat={valuetext}
      step={step}
      min={min}
      max={max}
      marks={marks}
      track={false}
      valueLabelDisplay="on"
      onChange={onChange}
      slots={{ thumb: AirbnbThumbComponent }}
      sx={{
        width: "100%",
      }}
    />
  );
};
